import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-uikit',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>UIkit icon</title><path d="M17.697 3.292l-4.109 2.489 4.738 2.696v7.077l-6.365 3.538-6.258-3.538v-5.485L1.596 7.956V18l10.219 6 10.589-6V6.002l-4.707-2.71zm-1.904-.989L11.813 0 7.665 2.568l4.032 2.218 4.096-2.483z"/></svg>`,
    styles: []
})
export class SimpleIconsUikitComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#2396F3';
    @Input() className: string = 'simple-icons-uikit'
    constructor() {}
    ngOnInit(): void {}
}
